import { Music } from 'lucide-react';
import { GuideCategory } from './types';

export const audioIntegrationGuide: GuideCategory = {
  id: 'audio-integration',
  title: 'Audio & Music',
  icon: Music,
  articles: [
    {
      slug: 'audio-library',
      title: 'Using the Audio Library',
      description: 'Explore our built-in sounds designed for ball physics sync.',
      sections: [
        {
          id: 'library-navigation',
          title: 'Browsing Sounds',
          content: 'The Audio tab features a library of royalty-free loops, melodies, and percussion tracks specifically curated for satisfying ball simulations. You can filter by genre, BPM, or intensity.',
          settingId: 'audio_library_list'
        },
        {
          id: 'auto-sync-presets',
          title: 'Quick Sync Presets',
          content: 'Many of our built-in tracks come with "Quick Sync" data. Selecting one of these will automatically configure your ball bounce settings to match the track\'s personality.',
          tips: ['Look for the "Sync-Ready" badge on library tracks for the best immediate results.']
        }
      ]
    },
    {
      slug: 'custom-audio',
      title: 'Uploading Custom Tracks',
      description: 'Bring your own music into the ball engine.',
      sections: [
        {
          id: 'upload-workflow',
          title: 'Uploading Audio Files',
          content: 'You can drag and drop your own MP3, WAV, or OGG files directly into the Studio. Once uploaded, the engine will analyze the waveform to create rhythmic triggers for your balls.',
          settingId: 'audio_upload_dropzone',
          technicalDetails: ['Max File Size: 10MB', 'Formats: .mp3, .wav, .ogg']
        },
        {
          id: 'waveform-analysis',
          title: 'Waveform & Beat Detection',
          content: 'After uploading, use the visualizer to see how the engine interprets your music. You can adjust the "Sensitivity" slider to capture more subtle beats or focus only on heavy bass hits.',
          settingId: 'audio_sensitivity_slider',
          tips: ['If your balls are reacting too often, try lowering the sensitivity threshold.']
        }
      ]
    }
  ]
};
